import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";
import { IComponentProps, SirenEntityBuilder } from "Common/utils/commonTypes";

//temporary solution
//related article mini boxes for article info on smaller screens
export const ArticleBoxMini: React.FC<IComponentProps> = (props: IComponentProps) => {
    const data: Record<string, any> = props.data ? props.data.properties || {} : null;
    if (!data) {
        return null;
    }
    const dataEntity: SirenEntityBuilder = EntityBuilder.of(props.data, { inplace: true });
    const title: string = dataEntity.getChild("title").getValue();
    const description: string = dataEntity.getChild("description").getValue();
    return (
        <div className="tq-banner un-lower-card">
            <h2 className="tq-panel-title">
                <span className="tq-text-node">{title}</span>
            </h2>
            <h2 className="tq-panel-title">
                <span className="tq-text-node">{description}</span>
            </h2>
        </div>
    );
};

export default webui.connectComponent()(ArticleBoxMini);
